<template >
  <div class="row">

    <!-- <div class="col-1 q-pt-sm text-center controls">
      <div><q-icon v-svg="getIcon('selectArea')" size="md" color="white" class="bg-black circle pointer q-pa-xs q-mt-sm" @click="router.push('/select'), clearMapStyle(), loadDataByID('FLAGS', version)"/><q-tooltip >Enter another area of interest</q-tooltip></div>
      <div><q-icon name="home" size="md" color="white" class="bg-black circle pointer  q-pa-xs q-mt-sm" @click="goTo('summary', 'FLAGS')"  :class="activePane == 'summary' ? 'shadow-1 highlight' : ''"/><q-tooltip >Summary of key considerations</q-tooltip></div>
      <div><q-icon v-svg="getIcon('featuresV2')" size="md" color="white" class="bg-black circle q-pa-xs q-mt-sm pointer"  @click="goTo('features')" :class="activePane == 'features' ? 'shadow-1 highlight' : ''"/><q-tooltip >Features tab</q-tooltip></div>
      <div><q-icon v-svg="getIcon('speciesV2')" size="md" color="white" class="bg-black circle  q-pa-xs q-mt-sm pointer"  @click="goTo('species')" :class="activePane == 'species' ? 'shadow-1 highlight' : ''"/><q-tooltip >Offshore species tab</q-tooltip></div>
      <div><q-icon v-svg="getIcon('coastalV2')" size="md"  color="white" class="bg-black circle  q-pa-xs q-mt-sm  pointer"   @click="goTo('coastal', 'COASTAL')" :class="activePane == 'coastal' ? 'shadow-1 highlight' : ''"/><q-tooltip >Coastal tab</q-tooltip></div>
      <div><q-icon v-svg="getIcon('peopleV2')" size="md"  color="white" class="bg-black circle q-mt-sm  q-pa-xs  pointer"  @click="goTo('people')" :class="activePane == 'people' ? 'shadow-1 highlight' : ''"/><q-tooltip >People tab</q-tooltip></div>
    </div> -->

    <div class="q-pt-sm q-pl-xs text-left controls" :class="showResultTabLabels ? 'col-3' : 'col-1'">
      <div class="text-right">
          <q-icon :name="showResultTabLabels ? 'chevron_left' : 'chevron_right'" size="sm" color="black" class="pointer q-mr-sm shadow-1 round" @click="toggleSecondColumn" aria-label="Show or hide the icon names"/>
          <q-tooltip>Show or hide the icon names</q-tooltip>
      </div>
      <div class="q-mt-sm  pointer" @click="router.push('/select'), clearMapStyle(), loadDataByID('FLAGS', version)">
        <q-icon v-svg="getIcon('selectArea')" size="md" color="white" class="bg-black circle pointer q-pa-xs" />
        <q-tooltip>Enter another area of interest</q-tooltip>
        <span class="label q-ml-sm text-uppercase" transition-show="slide-right" transition-hide="slide-left" v-if="showResultTabLabels">Select</span>
      </div>
      <div class="q-mt-sm  pointer" @click="goTo('summary', 'FLAGS')" :class="activePane == 'summary' && showResultTabLabels ? 'shadow-1 text-bold q-pa-xs' : ''">
        <q-icon name="home" size="md" color="white" class="bg-black circle pointer q-pa-xs" :class="activePane == 'summary' ? 'shadow-1 highlight' : ''" />
        <span class="label q-ml-sm text-uppercase q-pa-sm"  transition-show="slide-right" transition-hide="slide-left" v-if="showResultTabLabels">Summary</span>
        <q-tooltip>Summary of key considerations</q-tooltip>
      </div>
      <div class="q-mt-sm  pointer" @click="goTo('features')" :class="activePane == 'features' && showResultTabLabels ? 'shadow-1 text-bold q-pa-xs' : ''">
        <q-icon v-svg="getIcon('featuresV2')" size="md" color="white" class="bg-black circle q-pa-xs pointer" :class="activePane == 'features' ? 'shadow-1 highlight' : ''" />
        <span class="label q-ml-sm text-uppercase q-pa-sm" transition-show="slide-right" transition-hide="slide-left" v-if="showResultTabLabels">Features</span>
        <q-tooltip>Features tab</q-tooltip>
      </div>
      <div class="q-mt-sm  pointer" @click="goTo('species')"  :class="activePane == 'species' && showResultTabLabels ? 'shadow-1 text-bold q-pa-xs' : ''">
        <q-icon v-svg="getIcon('speciesV2')" size="md" color="white" class="bg-black circle q-pa-xs pointer" :class="activePane == 'species' ? 'shadow-1 highlight' : ''" />
        <span class="label q-ml-sm text-uppercase q-pa-sm" transition-show="slide-right" transition-hide="slide-left" v-if="showResultTabLabels">Species</span>
        <q-tooltip>Species tab</q-tooltip>
      </div>
      <div class="q-mt-sm  pointer" @click="goTo('coastal', 'COASTAL')" :class="activePane == 'coastal' && showResultTabLabels ? 'shadow-1 text-bold q-pa-xs' : ''">
        <q-icon v-svg="getIcon('coastalV2')" size="md" color="white" class="bg-black circle q-pa-xs pointer" :class="activePane == 'coastal' ? 'shadow-1 highlight' : ''" />
        <span class="label q-ml-sm text-uppercase q-pa-sm" transition-show="slide-right" transition-hide="slide-left" v-if="showResultTabLabels">Coastal</span>
        <q-tooltip>Coastal tab</q-tooltip>
      </div>
      <div class="q-mt-sm  pointer"  @click="goTo('people')" :class="activePane == 'people' && showResultTabLabels ? 'shadow-1 text-bold q-pa-xs' : ''">
        <q-icon v-svg="getIcon('peopleV2')" size="md" color="white" class="bg-black circle q-pa-xs pointer" :class="activePane == 'people' ? 'shadow-1 highlight' : ''" />
        <span class="label q-ml-sm text-uppercase q-pa-sm"  transition-show="slide-right" transition-hide="slide-left" v-if="showResultTabLabels">People</span>
        <q-tooltip>People tab</q-tooltip>
      </div>

    </div>



    
    <div class="col" ref="resultContentCol">    
      <div class="row  bg-primary result-pane-header-row" ref="result-pane-header-row">
        <div class="col-9 text-white q-pa-sm text-h5">
          <q-btn icon="arrow_back" @click="browserBack" class="q-mr-sm q-pl-xs q-pr-xs" aria-label="Go back">
            <q-tooltip>Go back to your previous screen</q-tooltip>
          </q-btn>
          {{ siteNames[version] }}</div>
        <div class="col-3">
          <div class="row justify-end">

            <q-input 
              v-if="showRename" 
              class="q-pl-sm q-ma-xs" 
              bg-color="white" 
              outlined dense label="Rename site" v-model="siteNames[version]"
              @update:model-value="nameSiteQPs()" aria-label="Enter a name for the analysis site"
              @keyup.enter="handleEnter">
              <q-tooltip>Enter a name for the site</q-tooltip>
            </q-input>
            <q-btn dense @click="showRename = !showRename" textColor="black" class="self-center q-ma-xs"
              :color="showRename ? 'white' : 'white'" aria-label="Click to rename a site">
              <q-icon name="edit" :color="showRename ? 'primary' : 'primary'" />
              <q-tooltip>Click to rename the site</q-tooltip>
            </q-btn>
            <q-btn dense @click="zoomToPolygon(thisPoly)" textColor="black" color="white" class="self-center q-ma-xs"
              aria-label="Zoom to the site" icon="search">
              <q-tooltip>Zoom to the site</q-tooltip>
            </q-btn>
            <q-btn dense @click="deleteAOI" textColor="black" color="white" class="self-center q-ma-xs"
              aria-label="Delete the AOI" icon="delete">
              <q-tooltip>Delete this AOI</q-tooltip>
            </q-btn>
          </div>
        </div>
      </div>

      <q-scroll-area :style="{'height': 'calc(100vh - 158px)', 'max-width': resultContentColWidth}">
          <router-view :rawData="cellData[version]" :version="version"></router-view>
      </q-scroll-area>


    </div>
  </div>


</template>
<script setup lang="ts">
// @ts-nocheck
import { toRefs, onMounted, ref, computed, watch } from 'vue';
import { useMapItems } from "../composables/useMapItems"
import { useHelpers } from "../composables/useHelpers"
import { useRouter, useRoute } from 'vue-router'
import * as turf from '@turf/turf'
import Flags from './Flags.vue'
import Species from './Species.vue'
import Features from './Features.vue'
import People from './People.vue'
import Coastal from './Coastal.vue'
import Table from './Table.vue';
import { useSvgIcon } from "../composables/useSvgIcon"

const route = useRoute()
const router = useRouter()
const { showResultTabLabels, setResultTabLabels, cellData, map, firstPanelClicks, setFirstPanelClicks, siteNames, setSiteNames, setCellData, setQueryParams, setUserPolygon, polyOffMap, processedData, mapLoaded, tileLayers, toggleLayer, activePane, setActivePane, clearMapStyle, zoomToPolygon, setProcessedData, loadDataByID } = useMapItems()
const { arrayFindObjectByProp, saveObjToFile, browserBack } = useHelpers();
const { getIcon } = useSvgIcon();

// result version number. Integer >= 1
const props = defineProps({
    version: {type: Number}
})
const { version } = toRefs(props)

// const loadData = (layerID) =>{
//   console.log("load data")
//   const layer = arrayFindObjectByProp(tileLayers.value, 'id', layerID)
//   toggleLayer(true, layer, version)
//   console.log(map.value)
// }

const thisPoly = ref(null)


const loadPoly = (nv, ov) => {
    // always start on Flags when moving between cellData.  We know that it exists from
    // the first time the polygon was loaded.  Then don't have to query another
    // layer if it's active from another reuslt

    let oldBaseRoute = null
    let oldPane = null
    if (ov != undefined){
      oldBaseRoute = ov.split("/")[1]
      oldPane = ov.split("/")[2]
    }
    const newBaseRoute = nv.split("/")[1]
    const newPane = nv.split("/")[2]

    // if it's the same baseRoute but a different nested route (someone coudl type in the nested)
    // then set the pane to == route so that left side icons reflect change
    if (oldPane && oldPane != newPane){
      setActivePane(newPane)
    }
    

    // on route change update the displayed cellData and user polygon
    const style = map.value.getStyle()
    if (style && Array.isArray(style.layers)) {
      style.layers
        .map((layer) => layer.id)
        .filter((id) => /^userPoly_\d+$/.test(id))
        .forEach((poly) => {
          if (map.value.getLayer(poly)) {
            map.value.removeLayer(poly)
          }

          const outlinedPoly = `${poly}_o`
          if (map.value.getLayer(outlinedPoly)) {
            map.value.removeLayer(outlinedPoly)
          }

          if (map.value.getSource(poly)) {
            map.value.removeSource(poly)
          }
        })
    }

    let data

    if (cellData.value[version.value]){
      if (cellData.value[version.value]['poly'] && cellData.value[version.value]['poly'].type != 'draw.create'){
        data =  cellData.value[version.value]['poly']
      }
      else if (cellData.value[version.value]['poly'] && cellData.value[version.value]['poly'].features){
        data = cellData.value[version.value]['poly'].features[0] 
      }
      setPolyAndZoom(data);
    }
    else if (processedData.value[version.value]){
      // console.log("exists")
      if (processedData.value[version.value]['poly'].type != 'draw.create'){
        data =  processedData.value[version.value]['poly']
      }
      else if (processedData.value[version.value]['poly'].features){
        // console.log(processedData.value[version.value]['poly'].features)
        data = processedData.value[version.value]['poly'].features[0]
      }
      // so can zoom to from butotn
      setPolyAndZoom(data);
    }
    else{
      // if loading from shared link, need to make sure it's ready
      map.value.once('idle', function(){
        // console.log("map laoded!")
        if (processedData.value[version.value]['poly'].type != 'draw.create'){
          data =  processedData.value[version.value]['poly']
        }
        else if (processedData.value[version.value]['poly'].features){
          // console.log(processedData.value[version.value]['poly'].features)
          data = processedData.value[version.value]['poly'].features[0]
        }
        setPolyAndZoom(data);
      })      
    }  
}

const setPolyAndZoom = (data) =>{
  // console.log(data)
  thisPoly.value = data;

  // make the current user polygon the active one.  This is the one taht will be updated
  // on layer change
  if (cellData.value[version.value] != undefined && cellData.value[version.value]['poly']){
    setUserPolygon(cellData.value[version.value]['poly'], version.value)
  }
  else if (processedData.value != undefined && processedData.value[version.value] !=undefined && processedData.value[version.value]['poly']){
    setUserPolygon(processedData.value[version.value]['poly'], version.value)
  }

  const sourceId = `userPoly_${version.value}`;
  if (!map.value.getSource(sourceId)) {
    map.value.addSource(sourceId, {
      type: 'geojson',
      data: data
    });
  } else {
    // console.log(`Source ${sourceId} already exists.`);
  }


  map.value.addLayer({
    'id': `userPoly_${version.value}_o`,
    'type': 'line',
    'source': `userPoly_${version.value}`,
    'paint': {
        'line-color': '#088',
        'line-width' : 3
    }
  });
  map.value.addLayer({
    'id': `userPoly_${version.value}`,
    'type': 'fill',
    'source': `userPoly_${version.value}`,
    'paint': {
        'fill-color': '#088',
        'fill-opacity': 0.4,
    }
  });


  if (polyOffMap.value){
    zoomToPolygon(data)
  }

}
watch(() => route.path, (nv, ov) => {
  if (mapLoaded.value){
    loadPoly(nv, ov)
  }
  else{
    watch(mapLoaded, (newValue, oldValue) => {
      loadPoly(nv, ov)
    }, { once: true });
  }
  

}, {immediate: true});

const showRename = ref(false)
const nameSiteQPs = () =>{
  setQueryParams({ [`name${version.value}`]: siteNames.value[version.value] })
  setProcessedData(version.value, "name", null, null, siteNames.value[version.value])
}


const clickAttrs = ref([])



const goTo = (pane, layerID=null) =>{

  setActivePane(pane)
  
  // in most cases, don't want to load data, because that happens on sub-panes
  // within the respective tab, but in some cases yes
  if (layerID){
    const layer = arrayFindObjectByProp(tileLayers.value, 'id', layerID)
    toggleLayer(true, layer, version)
  }

  // first time visiting a tab, go to Summary section
  let openPanel = pane
  // console.log(firstPanelClicks.value)
  // console.log(version.value)
  if (pane == 'species' && firstPanelClicks.value[version.value] && firstPanelClicks.value[version.value][pane]){
    openPanel = "species/summary"
  } 
  else if (pane == 'features' && firstPanelClicks.value[version.value] && firstPanelClicks.value[version.value][pane]){
    openPanel = "features/summary"
  } 
  else if (pane == 'people' && firstPanelClicks.value[version.value] && firstPanelClicks.value[version.value][pane]){
    openPanel = "people/summary"
  } 
  else if (pane == 'coastal' && firstPanelClicks.value[version.value] && firstPanelClicks.value[version.value][pane]){
    openPanel = "coastal/summary"
  } 
  setFirstPanelClicks(version.value, pane, false)
  router.push({
    path: `/results${version.value}/${openPanel}`
  })
  
}



const resultContentCol = ref(null)
const resultContentColWidth = computed(() => {
  if (resultContentCol.value){
      return resultContentCol.value.getBoundingClientRect().width;
  }
})

const deleteAOI = () =>{
  setProcessedData(version.value, "DELETE")
  setCellData("DELETE", null, null, version.value, null, null, null, null)
  setSiteNames(version.value, "DELETE")
  
  map.value.removeLayer(`userPoly_${version.value}`)
  map.value.removeLayer(`userPoly_${version.value}_o`)
  map.value.removeSource(`userPoly_${version.value}`)
  // console.log(cellData.value)
  // console.log(processedData.value)
  router.push('/select')
}

const toggleSecondColumn = () =>{
  setResultTabLabels(!showResultTabLabels)
}
const headerRow = ref(null)
const headerRowHeight = computed(() =>{
 return headerRow.value.offsetHeight

})

const handleEnter = (event) =>{
  event.target.blur();
  showRename.value = false;
}

onMounted(() => {

  // Example to trigger an uncaught error
  // setTimeout(() => {
  //     throw new Error('Test uncaught error');
  // }, 1000);
})

</script>
<style scoped>
.red{
  fill: red;
}
.circle{
  border-radius:50%;
}
.pointer{
  cursor: pointer;
}
.highlight{
  border: 3px solid #1D8177;
  border-radius:50%;
  box-shadow: 1px 3px 5px rgb(51, 51, 51);
  /* color: red */
}
.controls{
  background-color: #aeaeae;
}
.result-pane-header-row{
  border-top: 1px solid white;
}
.round{
  border-radius: 50%;
}
</style>